import { Component, OnInit, OnDestroy } from "@angular/core";
import { Product } from "../../shared/classes/product";
import { ProductService } from "../../shared/services/product.service";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { HttpClient } from "@angular/common/http";

import { map } from "rxjs";
import { TestimonialSlider } from "src/app/shared/data/slider";

@Component({
  selector: "app-furniture",
  templateUrl: "./furniture.component.html",
  styleUrls: ["./furniture.component.scss"],
})
export class FurnitureComponent implements OnInit, OnDestroy {
  public TestimonialSliderConfig: any = TestimonialSlider;

  posts: any = [];
  public testimonial = [
    {
      image:
        "https://expertphotography.b-cdn.net/wp-content/uploads/2020/08/profile-photos-4.jpg",
      name: "Mark jkcno",
      designation: "Designer",
      description:
        "you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings.",
    },
    {
      image:
        "https://expertphotography.b-cdn.net/wp-content/uploads/2020/08/social-media-profile-photos-3.jpg",
      name: "Adegoke Yusuff",
      designation: "Content Writer",
      description:
        "you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings.",
    },
    {
      image:
        "https://t3.ftcdn.net/jpg/04/60/91/88/360_F_460918802_XVCymFr7MoziFpnInbTDvrlblYhvAOi2.jpg",
      name: "John Shipmen",
      designation: "Lead Developer",
      description:
        "you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings.",
    },
  ];
  public themeLogo: string = "assets/images/icon/logo-12.png"; // Change Logo

  public products: Product[] = [];
  public productCollections: any[] = [
    {
      name: "New",
      value: "New",
      data: this.fire
        .collection("Products", (ref) =>
          ref.where("launchCategory", "==", "New").limit(8)
        )
        .valueChanges(),
    },
    {
      name: "Unique",
      value: "Unique",
      data: this.fire
        .collection("Products", (ref) =>
          ref.where("launchCategory", "==", "Unique").limit(8)
        )
        .valueChanges(),
    },
    {
      name: "In Offer",
      value: "Offers",
      data: this.fire
        .collection("Products", (ref) =>
          ref.where("launchCategory", "==", "Offers").limit(8)
        )
        .valueChanges(),
    },
    {
      name: "Reduced Items",
      value: "Reduced items",
      data: this.fire
        .collection("Products", (ref) =>
          ref.where("launchCategory", "==", "Reduced items").limit(8)
        )
        .valueChanges(),
    },
  ];
  public active;

  constructor(
    public productService: ProductService,
    private fire: AngularFirestore,
    private http: HttpClient
  ) {}

  public sliders = [];

  // Collection banner
  public collections = [
    {
      image:
        "https://ik.imagekit.io/brittiles/website/versache/MARBLE/82-549-GardeniaVersace-MarbleLiving-orizzontale-copia_jgzZz-833.jpg?updatedAt=1666950655888",
      title: "Tiles ",
      link: "/shop/products",
      value: "Tiles",
    },
    {
      image:
        "https://ik.imagekit.io/brittiles/Banner/Varsache2_i3XfgfSl6_XjnE5VUOs.jpg?updatedAt=1662032791808",
      title: "Tiles Accessories ",
      link: "/shop/products",
      value: "Tile Accessories",
    },
    {
      image:
        "https://ik.imagekit.io/brittiles/website/versache/eterno/110-643-IconsBaroccoBattiscopaCreamEternoWhite_hyGR0zokJ.jpg?updatedAt=1666950662863",
      title: "Bathroom Accessories",
      link: "/shop/products",
      value: "Bathroom Accessories",
    },
  ];

  // Blog
  public blogs = [
    {
      image:
        "https://angular.pixelstrap.com/multikart/assets/images/blog/14.jpg",
      date: "25 January 2018",
      title: "Lorem ipsum dolor sit consectetur adipiscing elit,",
      by: "John Dio",
    },
    {
      image:
        "https://angular.pixelstrap.com/multikart/assets/images/blog/15.jpg",
      date: "26 January 2018",
      title: "Lorem ipsum dolor sit consectetur adipiscing elit,",
      by: "John Dio",
    },
    {
      image:
        "https://angular.pixelstrap.com/multikart/assets/images/blog/16.jpg",
      date: "27 January 2018",
      title: "Lorem ipsum dolor sit consectetur adipiscing elit,",
      by: "John Dio",
    },
    {
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSIzNqwzxf5kQiLj8jWEEtwPxbNgucf7Eg6uA&usqp=CAU",
      date: "28 January 2018",
      title: "Lorem ipsum dolor sit consectetur adipiscing elit,",
      by: "John Dio",
    },
  ];

  ngOnInit(): void {
    // Change color for this layout
    // document.documentElement.style.setProperty("--theme-deafult", "#d4b196");
    this.getslides();
    this.getInstagramPosts();
  }

  getslides() {
    this.fire
      .collection("Home")
      .valueChanges()
      .subscribe((res) => {
        this.sliders = res;
      });
  }
  ngOnDestroy(): void {
    // Remove Color
    document.documentElement.style.removeProperty("--theme-deafult");
  }

  // Product Tab collection
  getCollectionProducts(collection) {
    return this.fire
      .collection("Products", (ref) =>
        ref.where("launchCategory", "==", collection?.value).limit(8)
      )
      .valueChanges();
  }
  onPostClick(post) {
    window.open(post?.permalink, "_blank");
  }
  getInstagramPosts() {
    const accessToken =
      "IGQVJYa0RrLU00ZAEdlSGptU18xSGJ5OEhSZAUtIZA3B5YTdyOVFEMjItbHJzRnN5cFI5SlVOc01rTGFVRUtCdWN2UkJmRngtZAHV3SmdxZAnBQVkxwc293cThrSlRIUmtueG9FRVJMOExoWENqd01wMjBUawZDZD";
    const apiUrl = `https://graph.instagram.com/me/media?fields=permalink,id,post_url,caption,media_type,media_url,thumbnail_url&access_token=${accessToken}`;

    this.http
      .get(apiUrl)
      .pipe(map((res: any) => res.data))
      .subscribe((posts) => {
        this.posts = posts;
      });
  }
}
